<div fxLayout="row" fxLayoutGap="20px" style="background-color: rgb(245, 242, 242);padding: 10px; margin-top: 10px; margin-bottom: 10px;">
    <div fxFlex="25" *ngIf="!basicMode">
        <h3>Select a custom date range:</h3>
        <div>
            <mat-form-field style="border: 0px;">
                <input matInput type="text"
                    [(ngModel)]="startDate"
                    [matDatepicker]="startDatePicker"
                    placeholder="Start date" />
                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
                <mat-error>
                    <span>Required</span>
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <input matInput type="text"
                    [(ngModel)]="endDate"
                    [matDatepicker]="endDatePicker"
                    placeholder="End date"/>
                <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #endDatePicker></mat-datepicker>
                <mat-error>
                    <span>Required</span>
                </mat-error>
            </mat-form-field>
           
        </div>
    </div>
    <div fxFlex="25">
        <h3>Select a financial year</h3>
        <mat-form-field class="mat-field-width">
            <mat-select [(ngModel)]="selectedYear"
                    (selectionChange)="onYearChanged()"
                    (openedChange)="onYearChanged()">
                <mat-option *ngFor="let y of years" [value]="y">
                    {{y.yearStart | date }} - {{y.yearEnd | date}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div>
        <button mat-raised-button
            color="primary"
            (click)="emitDates()"
            fxLayout="row" 
            fxLayoutAlign="center center"
            >
            <app-icon-core [icon]="'done'"></app-icon-core>
            <span>Run report</span>
        </button>
    </div>
</div>